export default "__VITE_ASSET__CG1DZh8T__"